module.exports = __webpack_public_path__ + "img/purchase5.42b5a72d.png";